import { compose } from 'redux'
import { downloadIOSApp } from '../../../../store/modules/mobileApps'
import View from './IOSAppBadge'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const mapDispatchToProps = dispatch => ({
  downloadIOSApp: compose(dispatch, downloadIOSApp),
})

const IOSAppBadge = connect(mapStateToProps, mapDispatchToProps)(View)

export default IOSAppBadge
